import React from 'react';
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import * as companiesCrud from '../../../../crud/companies.crud';
import * as companyUserCrud from '../../../../crud/companyUser.crud';
import * as contractUserCrud from '../../../../crud/contractUser.crud';
import * as contractDuck from '../../../../store/ducks/contract.duck';
import { contractRoleTypes, GetCurrencyCodes } from "../../../../shared/lookup";
import PortletSpinner from '../../../../partials/layout/PortletSpinner';
import DataGrid, { Lookup, Column, SearchPanel, Export, ColumnChooser, ColumnFixing, Editing, HeaderFilter, Summary, TotalItem, Scrolling, Form, Toolbar, Item as ToolbarItem, Selection, Button } from 'devextreme-react/data-grid';
import { FormattedMessage, injectIntl } from "react-intl";
import moment from 'moment';
import { Item as FormItem } from 'devextreme-react/form';
import { confirm } from 'devextreme/ui/dialog';
import Common from '../../../../shared/common';
import { dxNumberBoxProps } from '../../../../shared/config/DxFormProperties';
import { custom as CustomDialog } from 'devextreme/ui/dialog';
import * as userCrud from '../../../../crud/user.crud';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import MigrationHelper from "../../../../shared/migrationHelper";
import { listAccountsAllowedRegisterBatchOperations, listAccountsAllowedRegisterBatchOperationsWhenEnabled } from '../../../../router/Protector/AccessExceptions';
import SystemHelper from "../../../../shared/systemHelper";

const isFinancialLimitEnabled = process.env.REACT_APP_FINANCIAL_LIMIT_ENABLED === "true";
const isShowMultipleUsersOnDashboardEnabled = process.env.REACT_APP_SHOW_MULTIPLE_USERS_ON_DASHBOARD_ENABLED === "true";

class ContractUsers extends React.Component {
    constructor(props) {
        super(props);
        this.gridRef = React.createRef();
        this.fileImportInputRef = React.createRef();
        this.currencyCodes = GetCurrencyCodes(props.intl);
        this.contractPartyTypesAll = [
            { value: 'PM', display: this.props.contractTemplate.resources.PM_NAME },
            { value: 'Contractor', display: this.props.contractTemplate.resources.SUPPLIER_NAME },
            { value: 'Supervisor', display: this.props.contractTemplate.resources.SUPERVISOR_NAME },
            { value: 'Client', display: this.props.contractTemplate.resources.CLIENT_NAME },
        ];

        this.contractPartyTypesAll = this.contractPartyTypesAll.sort((a, b) => a.display.localeCompare(b.display));
        this.companyUserDataSources = {};
        this.emptyUserDataSource = [];

        switch (props.contract.partystructure) {
            case 1:
                this.contractPartyTypesAvailable = this.contractPartyTypesAll.filter(p => p.value !== 'Client' && p.value !== 'Supervisor');
                break;
            case 2:
                this.contractPartyTypesAvailable = this.contractPartyTypesAll.filter(p => p.value !== 'Supervisor');
                break;
            case 3:
                this.contractPartyTypesAvailable = [...this.contractPartyTypesAll];
                break;
            case 4:
                this.contractPartyTypesAvailable = this.contractPartyTypesAll.filter(p => p.value !== 'Client');
                break;
            default:
                this.contractPartyTypesAvailable = [...this.contractPartyTypesAll];
                break;
        }

        this.toolbarBatchButtonRefs = [];

        this.allowEdit = this.props.protectedRouteProps.allowEdit;
        this.allowSeeFinancialFields = isFinancialLimitEnabled && this.props.contract.financiallimitenabled && this.props.protectedRouteProps.allowSeeFinancialFields;
        this.allowSeeDashboardButtons = isShowMultipleUsersOnDashboardEnabled && this.props.protectedRouteProps.allowSeeDashboardButtons;
        this.allowSeeExportAccessButton = this.props.protectedRouteProps.allowSeeExportAccessButton;

        this.batchOperationsEnabled = false;
        if (process.env.REACT_APP_BATCH_OPERATIONS_ENABLED === "true") {
            //REGISTER SUPPORTS BATCH OPERATION
            if (listAccountsAllowedRegisterBatchOperations.includes(this.props.userProfile.accounttype)) {
                this.batchOperationsEnabled = true;
            }
        }

        this.state = {
            isBusy: true,
            contractUsers: null,
            companyOptions: null,
            batchEditing: false,
            showCommunicateModal: false,
            formFields: null,
            batchUnsupportedCustomFieldWarning: null,
            showContractEmailSwitch: false
        }
    }

    getFormConfig = () => {
        if (process.env.REACT_APP_BATCH_OPERATIONS_ENABLED === "true") {
            const fields = [
                {
                    caption: this.props.intl.formatMessage({ id: 'CONTRACT.USERS.FIELD.COMPANY' }),
                    dataField: 'companyid',
                    required: true,
                    dataType: 'list',
                    options: {
                        dataSource: this.state.companyOptions,
                        valueExpr: 'companyid',
                        displayExpr: 'name'
                    }
                }
            ];

            fields.push({
                caption: this.props.intl.formatMessage({ id: 'CONTRACT.USERS.FIELD.USER' }),
                dataField: 'userid',
                required: true,
                dataType: 'integer'
                // dataType: 'list',
                // options: {
                //     dataSource: this.getCompanyUserDataSource,
                //     valueExpr: 'accountid',
                //     displayExpr: 'display'
                // }
            });

            fields.push({
                caption: this.props.intl.formatMessage({ id: 'CONTRACT.USERS.FIELD.PARTY' }),
                dataField: 'usergroup',
                required: true,
                dataType: 'list',
                options: {
                    dataSource: this.contractPartyTypesAll,
                    valueExpr: 'value',
                    displayExpr: 'display'
                }
            });

            fields.push({
                caption: this.props.intl.formatMessage({ id: 'CONTRACT.USERS.FIELD.ROLE' }),
                dataField: 'rolepermissions',
                required: true,
                dataType: 'list',
                options: {
                    dataSource: contractRoleTypes
                }
            });

            fields.push({
                caption: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.COMMENTS' }),
                dataField: 'comments',
                dataType: 'string'
                //required: true,
            });


            fields.push({
                caption: this.props.intl.formatMessage({ id: 'CONTRACT.USERS.FIELD.CONTRACT_EMAILS_DISABLED' }),
                dataField: 'disablecontractemails',
                required: true,
                dataType: 'bool'
            });




            if (this.props.contract.financiallimitenabled && this.allowSeeFinancialFields) {
                fields.push({
                    caption: this.props.intl.formatMessage({ id: "GENERAL.FORMS.FINANCIAL_LIMIT" }) + ' ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.AMOUNT' }),
                    dataField: 'userlimit',
                    required: true,
                    dataType: 'integer'
                });

                fields.push({
                    caption: this.props.intl.formatMessage({ id: "GENERAL.FORMS.FINANCIAL_LIMIT" }) + ' ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.CURRENCY' }),
                    dataField: 'userlimitcurrency',
                    required: true,
                    dataType: 'list',
                    options: {
                        dataSource: this.currencyCodes,
                        valueExpr: 'code',
                        displayExpr: 'name'
                    }
                });
            }

            const { formFields, unsupportedCustomFieldWarning } = MigrationHelper.getFormFieldsConfig(fields, { id: 0, name: 'ContractUsers' }, this.props.customFields);

            this.setState({ formFields, batchUnsupportedCustomFieldWarning: unsupportedCustomFieldWarning });
        }
    }

    componentDidMount() {
        this.loadCompanyOptions();
        this.fetchContractUsers();
    }
    fetchContractUsers = async () => {
        this.setState({ isBusy: true }, async () => {
            const { contractid } = this.props.contract;
            const { data: contractUsers } = await contractUserCrud.getContractUsers(contractid);
            this.setState({ contractUsers, isBusy: false });
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.contractUsers !== nextState.contractUsers) {
            return true;
        }
        if (this.state.batchEditing !== nextState.batchEditing) {
            return true;
        }
        if (this.state.showCommunicateModal !== nextState.showCommunicateModal) {
            return true;
        }
        if (this.state.isBusy !== nextState.isBusy) {
            return true;
        }
        if (this.state.companyOptions !== nextState.companyOptions) {
            return true;
        }
        // console.log("Re-render blocked")
        return false;
    }

    loadCompanyOptions = async () => {
        try {
            const { data: companies } = await companiesCrud.getCutDownCompaniesList();
            this.setState({ companyOptions: companies }, () => this.getFormConfig());
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
    }
    //TODO: Check before create and display warning
    checkIsUserPartyMatchedContractPartyCompany = async (user) => {
        let partySelectionMatchesContractCompany = false;
        switch (user.usergroup) {
            case "Contractor":
                partySelectionMatchesContractCompany = this.props.contract.contractorcompanyid === user.companyid;
                break;
            case "PM":
                partySelectionMatchesContractCompany = this.props.contract.pmcompanyid === user.companyid;
                break;
            case "Supervisor":
                partySelectionMatchesContractCompany = this.props.contract.supervisorcompanyid === user.companyid;
                break;
            case "Client":
                partySelectionMatchesContractCompany = this.props.contract.employercompanyid === user.companyid;
                break;
            default:
                break;
        }

        if (!partySelectionMatchesContractCompany) {
            let result = await confirm(`<div style="max-width:50vw;">${this.props.intl.formatMessage({ id: "CONTRACT.USERS.WARNING_TEXT" })}</div>`, this.props.intl.formatMessage({ id: "CONTRACT.USERS.WARNING_TITLE" }));
            return result;
        }
        else {
            return true;
        }
    }
    addUserToContractPromise = (newContractUser, e) => {
        return new Promise(async (resolve, reject) => {
            try {
                const checkPassed = await this.checkIsUserPartyMatchedContractPartyCompany(newContractUser);
                if (checkPassed) {
                    const { companyid, projectid, contractid } = this.props.contract;
                    newContractUser.createbyid = this.props.userProfile.accountid;
                    newContractUser.companyid = companyid;
                    newContractUser.projectid = projectid;
                    newContractUser.contractid = contractid;
                    const resp = await contractUserCrud.saveContractUser(newContractUser);
                    e.data.contractuserid = resp.data;
                    this.fetchContractUsers();
                    this.props.refreshContractUsers();
                    resolve(false);
                }
                else {
                    reject(this.props.intl.formatMessage({ id: "CONTRACT.USERS.WARNING_TITLE" }))
                }


            } catch (error) {
                console.log(error);
                reject(error)
            }
        });
    }

    deleteContractUserPromise = (contractid, contractuserid) => {
        return new Promise(async (resolve, reject) => {
            try {
                await contractUserCrud.deleteContractUser(contractid, contractuserid);
                this.fetchContractUsers();
                this.props.refreshContractUsers();
                resolve(false);
            } catch (error) {
                console.log(error);
                reject(error)
            }
        });
    }

    //deleting row
    onRowRemoving = async (e) => {
        const { contractid } = this.props.contract;
        e.cancel = this.deleteContractUserPromise(contractid, e.data.contractuserid);
    }

    //adding row
    onRowInserting = async (e) => {

        const newContractUser = { ...e.data, usersource: 'Account' };
        if (isFinancialLimitEnabled && this.props.contract.financiallimitenabled) {
            // if (!newContractUser.userlimit) {
            //     newContractUser.userlimit = 0;
            // }
            newContractUser.userlimitcurrency = this.props.contract.currency;
        }
        e.cancel = this.addUserToContractPromise(newContractUser, e);
    }

    onInitNewRow = async (e) => {
        e.data = { deleted: 0, usercompanyid: null  };
        if (isFinancialLimitEnabled && this.props.contract.financiallimitenabled) {
            e.data.userlimitcurrency = this.props.contract.currency;
        }
    }
    // onRowValidating = async (e) => {
    //     const newObject = { ...e.oldData, ...e.newData };
    //     e.promise = new Promise(async (resolve, reject) => {
    //         const checkPassed = true;
    //         if (!checkPassed) {
    //             e.errorText = "Some error";
    //             e.isValid = false;
    //         }
    //         //DONT CHANGE STATUS IN OTHER CASES
    //         resolve();
    //     });
    // }

    getCompanyUserDataSource = (options = {}, overrides = {}) => {
    const { contractid } = this.props.contract;

    // 🔹 resolve values from either overrides OR options
    const data = options.data || {};

    const usercompanyid =
        overrides.usercompanyid ??
        data.usercompanyid ??
        data.companyid; // fallback if needed

    const contractuseraccountid =
        overrides.userid ??
        data.userid ??
        null;

    if (!usercompanyid) return this.emptyUserDataSource;

    const key = `${usercompanyid}_${contractid}_${contractuseraccountid || 'null'}`;

    if (!this.companyUserDataSources[key]) {
        this.companyUserDataSources[key] = {
            loadMode: 'raw',
            cacheRawData: true,
            load: () => {
                return companyUserCrud
                    .getCompanyUsersToSelectListForContract(
                        usercompanyid,
                        contractid,
                        contractuseraccountid
                    )
                    .then(response => {
                        let users = response.data;

                        if (users.length < 1) {
                            this.props.enqueueSnackbar(
                                this.props.intl.formatMessage({ id: "WARNING.COMPANY_HAS_NO_USERS" }),
                                { variant: 'warning' }
                            );
                        }

                        return users.map(user => ({
                            accountid: user.accountid,
                            display: `${user.name} (${user.email})`
                        }));
                    });
            }
        };
    }

    return this.companyUserDataSources[key];
};

    //USED FOR CASCADING FORM FIELDS
    setCompanyCellValue(rowData, value) {
        rowData.userid = null;
        rowData.usercompanyid = value;
        this.defaultSetCellValue(rowData, value);
    }
    calculateEmailState = (rowData) => {
        if (rowData.disableglobalemailnotifications) {
            return true;
        }
        else {
            return false
        }
    }

    calculateContractEmailState = (rowData) => {
        if (rowData.disablecontractemails) {
            return true;
        }
        else {
            return false
        }
    }

    onbtnRemoveFromDashboardClick = async () => {
        try {
            const selection = this.gridRef.current.instance().getSelectedRowKeys();
            if (selection.length) {
                let activateDialog = CustomDialog({
                    title: this.props.intl.formatMessage({ id: 'GENERAL.USER_REMOVING_CONTRACT_DASHBOARD' }, { LENGTH: selection.length }),
                    messageHtml: `<div style="max-width:50vw;">${this.props.intl.formatMessage({ id: 'GENERAL.USER_ABOUT_TO_REMOVE_CONTRACT_DASHBOARD' }, { LENGTH: selection.length })} </div>`,
                    buttons: [
                        {
                            text: "Cancel",
                            onClick: (e) => { return "CANCEL" }
                        },
                        {
                            text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.REMOVE_FROM_DASHBOARD" }),
                            type: "danger",
                            stylingMode: "outlined",
                            onClick: (e) => { return "HIDE" }
                        }
                    ]
                });
                const result = await activateDialog.show();
                if (result === "HIDE") {
                    const formData = {
                        contractUserIds: selection,
                        actionType: result,
                        contractId: this.props.contract.contractid
                    };

                    await userCrud.bulkShowHideUsersOnDashboard(formData);
                    this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "GENERAL.USER_REMOVED_CONTRACT_DASHBOARD" }), { variant: "success" });
                    this.fetchContractUsers();
                    this.props.refreshContractUsers();
                    this.gridRef.current.instance().clearSelection();
                }
            }
        }
        catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: "error" });
        }
    }

    onbtnShowOnDashboardClick = async () => {
        try {
            const selection = this.gridRef.current.instance().getSelectedRowKeys();
            if (selection.length) {
                let activateDialog = CustomDialog({
                    title: this.props.intl.formatMessage({ id: 'GENERAL.USER_SHOWING_CONTRACT_DASHBOARD' }, { LENGTH: selection.length }),
                    messageHtml: `<div style="max-width:60vw;">${this.props.intl.formatMessage({ id: 'GENERAL.USER_ABOUT_TO_SHOW_CONTRACT_DASHBOARD' }, { LENGTH: selection.length })} </div>`,
                    buttons: [
                        {
                            text: "Cancel",
                            onClick: (e) => { return "CANCEL" }
                        },
                        {
                            text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SHOW_ON_DASHBOARD" }),
                            type: "success",
                            stylingMode: "outlined",
                            onClick: (e) => { return "SHOW" }
                        }
                    ]
                });
                const result = await activateDialog.show();
                if (result === "SHOW") {
                    const formData = {
                        contractUserIds: selection,
                        actionType: result,
                        contractId: this.props.contract.contractid
                    };

                    await userCrud.bulkShowHideUsersOnDashboard(formData);
                    this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "GENERAL.USER_ADDED_CONTRACT_DASHBOARD" }), { variant: "success" });
                    this.fetchContractUsers();
                    this.props.refreshContractUsers();
                    this.gridRef.current.instance().clearSelection();
                }
            }
        }
        catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: "error" });
        }
    }



    onbtnRevokeExportAccessClick = async () => {
        try {
            const selection = this.gridRef.current.instance().getSelectedRowKeys();
            if (selection.length) {
                let activateDialog = CustomDialog({
                    title: this.props.intl.formatMessage({ id: 'GENERAL.USER_REVOKING_EXPORT_ACCESS' }, { LENGTH: selection.length }),
                    messageHtml: `<div style="max-width:50vw;">${this.props.intl.formatMessage({ id: 'GENERAL.USER_ABOUT_TO_REVOKE_EXPORT_ACCESS' }, { LENGTH: selection.length })} </div>`,
                    buttons: [
                        {
                            text: "Cancel",
                            onClick: (e) => { return "CANCEL" }
                        },
                        {
                            text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.REVOKE_EXPORT_ACCESS" }),
                            type: "danger",
                            stylingMode: "outlined",
                            onClick: (e) => { return "DISABLE" }
                        }
                    ]
                });
                const result = await activateDialog.show();
                if (result === "DISABLE") {
                    const formData = {
                        contractUserIds: selection,
                        actionType: result,
                        contractId: this.props.contract.contractid
                    };

                    await userCrud.bulkEnableDisableExportAccess(formData);
                    this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "GENERAL.USER_REVOKED_EXPORT_ACCESS" }), { variant: "success" });
                    this.fetchContractUsers();
                    this.props.refreshContractUsers();
                    this.gridRef.current.instance().clearSelection();
                }
            }
        }
        catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: "error" });
        }
    }

    onbtnGrantExportAccessClick = async () => {
        try {
            const selection = this.gridRef.current.instance().getSelectedRowKeys();
            if (selection.length) {
                let activateDialog = CustomDialog({
                    title: this.props.intl.formatMessage({ id: 'GENERAL.USER_GRANTING_EXPORT_ACCESS' }, { LENGTH: selection.length }),
                    messageHtml: `<div style="max-width:60vw;">${this.props.intl.formatMessage({ id: 'GENERAL.USER_ABOUT_TO_GRANT_EXPORT_ACCESS' }, { LENGTH: selection.length })} </div>`,
                    buttons: [
                        {
                            text: "Cancel",
                            onClick: (e) => { return "CANCEL" }
                        },
                        {
                            text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.GRANT_EXPORT_ACCESS" }),
                            type: "success",
                            stylingMode: "outlined",
                            onClick: (e) => { return "ENABLE" }
                        }
                    ]
                });
                const result = await activateDialog.show();
                if (result === "ENABLE") {
                    const formData = {
                        contractUserIds: selection,
                        actionType: result,
                        contractId: this.props.contract.contractid
                    };

                    await userCrud.bulkEnableDisableExportAccess(formData);
                    this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "GENERAL.USER_GRANTED_EXPORT_ACCESS" }), { variant: "success" });
                    this.fetchContractUsers();
                    this.props.refreshContractUsers();
                    this.gridRef.current.instance().clearSelection();
                }
            }
        }
        catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: "error" });
        }
    }




    onSelectionChanged = ({ selectedRowKeys }) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys.length <= 100) {
            if (this.btnShowOnDashboard) { this.btnShowOnDashboard.component.option("disabled", false); }
            if (this.btnRemoveFromDashboard) { this.btnRemoveFromDashboard.component.option("disabled", false); }
            if (this.btnGrantExportAccess) { this.btnGrantExportAccess.component.option("disabled", false); }
            if (this.btnRevokeExportAccess) { this.btnRevokeExportAccess.component.option("disabled", false); }
        } else {
            if (this.btnShowOnDashboard) { this.btnShowOnDashboard.component.option("disabled", true); }
            if (this.btnRemoveFromDashboard) { this.btnRemoveFromDashboard.component.option("disabled", true); }
            if (this.btnGrantExportAccess) { this.btnGrantExportAccess.component.option("disabled", true); }
            if (this.btnRevokeExportAccess) { this.btnRevokeExportAccess.component.option("disabled", true); }
        }
        if (selectedRowKeys.length > 100) {
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "GENERAL.USER_SELECTION_LIMIT" }), { variant: "warning" });
        }
    }
    onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ContractUsers.xlsx');
                });
        });
    }

    downloadImportTemplateClick = async () => {
        const workbook = MigrationHelper.getExcelTemplate(this.state.formFields, this.props.contract?.currency);

        const name = 'ContractUsers';
        const documentName = "Import_" + name.replace(/\s/g, "") + '.xlsx';
        // await workbook.xlsx.writeFile("first xls file");

        // https://github.com/exceljs/exceljs#writing-xlsx
        workbook.xlsx.writeBuffer()
            .then(function (buffer) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), documentName);
            })
            .catch(err => {

                // this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'ACTIONS.TOAST.IMPORTED' }, { COUNT: itemCount }), { variant: 'success', });

                console.log(err);
            });
    }

    importFileSelected = async (e) => {
        if (e.stopPropagation) { e.stopPropagation(); }
        if (e.preventDefault) { e.preventDefault(); }
        if (e.target && e.target.files && e.target.files.length > 0) {
            var file = e.target.files[0];
            if (file) {
                this.props.closeSnackbar();
                this.setState({ isBusy: true }, async () => {
                    try {
                        this.gridRef.current.instance().beginCustomLoading("Processing file...");
                        // if (!this.props.workflowItem) {
                        //     throw new Error("Workflow item not provided!")
                        // }
                        const dataCommonProperties = {
                            workflowid: this.props.workflowItem?.id,
                            notifyingparty: this.props.workflowItem?.notifyingParty,
                            replyingparty: this.props.workflowItem?.replyingParty,
                            quotingparty: this.props.workflowItem?.quotingParty,
                            quotereplyingparty: this.props.workflowItem?.quoteReplyingParty,
                            actioningparty: this.props.workflowItem?.actioningParty,
                        }
                        const data = await MigrationHelper.processExcelFile(file, this.state.formFields, dataCommonProperties, this.props.customFields, this.state.contractUsers);
                        if (!data || data.length === 0) {
                            throw new Error("No data found!")
                        }
                        let activateDialog = CustomDialog({
                            title: this.props.intl.formatMessage({ id: 'BATCH_OPS.POPUP.IMPORT.TITLE' }, { COUNT: data.length }),
                            messageHtml: `<div style="max-width:60vw;">${this.props.intl.formatMessage({ id: 'BATCH_OPS.POPUP.IMPORT.MESSAGE' }, { COUNT: data.length })}</div>`,
                            buttons: [
                                {
                                    text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                                    onClick: (e) => { return "CANCEL" }
                                },
                                {
                                    text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CREATE_DRAFT" }),
                                    type: "default",
                                    stylingMode: "outlined",
                                    onClick: (e) => { return "CONTINUE" }
                                }
                            ]
                        });
                        const result = await activateDialog.show();
                        if (result === "CONTINUE") {
                            console.log(this.props.contract);
                            const requestObj = {
                                contractid: this.props.contract?.contractid,
                                workflowid: this.props.workflowItem?.id,
                                data
                            }
                            const { data: batchResult } = await contractUserCrud.importContractUsers(requestObj);

                            if (batchResult.successfulrecordcount > 0) {
                                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'ACTIONS.TOAST.IMPORTED' }, { COUNT: batchResult.successfulrecordcount }), { variant: 'success', });
                            }
                            if (batchResult.error) {
                                console.log(batchResult.error)
                                this.props.enqueueSnackbar(batchResult.error, { variant: 'error', persist: true });
                            }

                            if (batchResult.successfulrecordcount === 0 && !batchResult.error) {
                                //NO IMPORT & NO ERROR
                                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'ACTIONS.TOAST.IMPORTED_NONE' }), { variant: 'warning', });
                            }
                            this.fetchContractUsers();
                            this.props.refreshContractUsers();
                        }

                    } catch (err) {
                        this.props.enqueueSnackbar(err.toString(), { variant: 'error', persist: true });
                        console.log(err.toString())
                    }
                    finally {
                        if (this.fileImportInputRef.current) {
                            this.fileImportInputRef.current.value = null;
                        }
                        this.gridRef.current.instance().endCustomLoading();
                        this.setState({ isBusy: false })
                    }
                })

            }
        }
    }

    importExcelClicked = (e) => {
        if (this.fileImportInputRef.current) {
            this.fileImportInputRef.current.click();
        }
    }

    onRowUpdating = async (e) => {
        e.cancel = this.updateContractUserPromise(e.oldData, e.newData);
    }

    updateContractUserPromise = (oldData, newData) => {
        return new Promise(async (resolve, reject) => {
            const { companyid, projectid, contractid } = this.props.contract;
            try {
                const newObject = { ...oldData, ...newData };
                if (oldData.companyid !== newObject.companyid) {
                    return reject("Company cannot be changed.");
                };
                if (oldData.userid !== newObject.userid) {
                    return reject("User cannot be changed.");
                };
                if (oldData.usergroup !== newObject.usergroup) {
                    return reject("Party cannot be changed.");
                };
                if (oldData.rolepermissions !== newObject.rolepermissions) {
                    return reject("Role cannot be changed.");
                };
                if (oldData.userlimit !== newObject.userlimit) {
                    return reject("User limit cannot be changed.");
                };
                if (oldData.userlimitcurrency !== newObject.userlimitcurrency) {
                    return reject("User limit currency cannot be changed.");
                };
                newObject.contractid = contractid;
                newObject.projectid = projectid;
                await contractUserCrud.saveContractUser(newObject);
                resolve(false);
            } catch (error) {
                console.log(error);
                reject(error)
            }
        });
    }

    render() {
        if (!this.props.contract) {
            return (<PortletSpinner />);
        }
        
        return (
            <Portlet isLoading={this.state.isBusy} loadingDelay={0}>
                <PortletBody>
                    <DataGrid
                        dataSource={this.state.contractUsers}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={this.state.batchEditing ? true : false}
                        showBorders={true}
                        showColumnLines={true}
                        showRowLines={true}
                        remoteOperations={false}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        columnResizingMode="widget"
                        onRowRemoving={this.onRowRemoving}
                        onInitNewRow={this.onInitNewRow}
                        onRowInserting={this.onRowInserting}
                        onRowUpdating={this.onRowUpdating}
                        onEditorPreparing={(e) => {
                            if (e.dataField === "userid" && e.parentType === "dataRow") {
                                if (e.editorOptions.dataSource) return;

                                const formData = e.row?.data;

                                e.editorOptions.dataSource = this.getCompanyUserDataSource({}, {
                                    usercompanyid: formData?.usercompanyid,
                                    userid: formData?.userid
                                });
                            }
                        }}
                        style={{ maxHeight: "67vh", minHeight: "50vh" }}
                        name="ContractUsers"
                        keyExpr="contractuserid"
                        loadPanel={{ showIndicator: !this.state.contractUsers }}
                        onSelectionChanged={this.onSelectionChanged}
                        ref={this.gridRef}
                        onExporting={this.onExporting}
                    >
                        {(this.allowSeeDashboardButtons || this.allowSeeExportAccessButton) && (
                            <Selection
                                mode="multiple"
                                selectAllMode="allPages"
                                showCheckBoxesMode="always"
                            />
                        )}

                        {/* ---------------- EDITING ---------------- */}
                        <Editing
                            mode="popup"
                            allowUpdating={this.allowEdit}
                            allowDeleting={this.allowEdit}
                            allowAdding={this.allowEdit}
                            confirmDelete={true}
                            useIcons={true}
                            popup={{
                                title: this.props.intl.formatMessage({ id: "CONTRACT.USERS.ADD_CONTRACT_USER" }),
                                minWidth: 600,
                                height: "auto",
                                width: "auto",
                                showTitle: true
                            }}
                            texts={{
                                confirmDeleteTitle: this.props.intl.formatMessage({ id: "CONTRACT.USERS.REMOVE_USER" }),
                                confirmDeleteMessage: this.props.intl.formatMessage({ id: "CONTRACT.USERS.REMOVE_MESSAGE" })
                            }}
                        >
                            <Form
                                customizeItem={(item) => {
                                    // READ-ONLY ONLY WHEN EDITING EXISTING ROWS
                                    if (!item || !item.formData) return;
                                    const isEdit = !!item.formData.contractuserid;
                                    if (isEdit && item.editorOptions) {
                                        item.editorOptions.readOnly = true;
                                    }
                                }}
                            >
                                <FormItem colSpan={2} dataField="companyid" isRequired />
                                <FormItem
                                    colSpan={2}
                                    dataField="userid"
                                    isRequired
                                    editorType="dxSelectBox"
                                    editorOptions={{
                                        valueExpr: "accountid",
                                        displayExpr: "display"
                                    }}
                                />

                                <FormItem
                                    colSpan={2}
                                    dataField="usergroup"
                                    isRequired
                                    editorOptions={{
                                        dataSource: this.contractPartyTypesAvailable,
                                        valueExpr: "value",
                                        displayExpr: "display"
                                    }}
                                />

                                <FormItem colSpan={2} dataField="rolepermissions" isRequired />
                                <FormItem colSpan={2} dataField="comments" />
                                <FormItem
                                    colSpan={2}
                                    dataField="disablecontractemails"
                                    editorType="dxCheckBox"
                                />

                                {/* Financial Limits */}
                                {this.props.contract.financiallimitenabled && this.allowSeeFinancialFields && (
                                    <FormItem
                                        colSpan={2}
                                        itemType="group"
                                        caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.FINANCIAL_LIMIT" })}
                                    >
                                        <FormItem
                                            colSpan={2}
                                            dataField="userlimit"
                                            editorType="dxNumberBox"
                                            label={{ text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.AMOUNT" }) }}
                                            editorOptions={{ ...dxNumberBoxProps(this.props.contract.currency) }}
                                        />

                                        <FormItem
                                            colSpan={2}
                                            dataField="userlimitcurrency"
                                            editorType="dxSelectBox"
                                            label={{ text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.CURRENCY" }) }}
                                            editorOptions={{
                                                dataSource: this.currencyCodes,
                                                valueExpr: "code",
                                                displayExpr: "name",
                                                readOnly: true,
                                                width: 200
                                            }}
                                        />
                                    </FormItem>
                                )}
                            </Form>
                        </Editing>

                        {/* ---------------- FILTERS / FEATURES ---------------- */}
                        <HeaderFilter visible={true} />
                        <ColumnChooser enabled={true} />
                        <ColumnFixing enabled={true} />
                        <Export
                            enabled={true}
                            fileName={this.props.intl.formatMessage({ id: "CONTRACT.USERS.TITLE" })}
                        />
                        <SearchPanel visible={true} highlightCaseSensitive={false} />

                        {/* ---------------- DATA COLUMNS ---------------- */}
                        <Column
                            caption={this.props.intl.formatMessage({ id: "CONTRACT.USERS.FIELD.COMPANY" })}
                            dataField="usercompany"
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "CONTRACT.USERS.FIELD.NAME" })}
                            dataField="user"
                        />
                        <Column
                            caption={this.props.intl.formatMessage({ id: "CONTRACT.USERS.FIELD.EMAIL" })}
                            dataField="useremail"
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "CONTRACT.USERS.FIELD.PARTY" })}
                            dataField="usergroup"
                            lookup={{ dataSource: this.contractPartyTypesAll, valueExpr: "value", displayExpr: "display" }}
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "CONTRACT.USERS.FIELD.ROLE" })}
                            dataField="rolepermissions"
                            lookup={{ dataSource: contractRoleTypes }}
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.FIELD.COMMENTS" })}
                            dataField="comments"
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "CONTRACT.USERS.FIELD.LAST_EDITED" })}
                            dataField="dateadded"
                            dataType="date"
                            format={(date) => moment(date).format("DD/MM/YYYY HH:mm")}
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "CONTRACT.USERS.FIELD.CONTRACT_EMAILS_DISABLED" })}
                            dataField="disablecontractemails"
                            calculateCellValue={this.calculateContractEmailState}
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "CONTRACT.USERS.FIELD.EMAILS_DISABLED" })}
                            dataField="disableglobalemailnotifications"
                            calculateCellValue={this.calculateEmailState}
                        />

                        <Column
                            caption={this.props.intl.formatMessage({ id: "COMPANY.USER.FIELD.EMAILS_OPTEDOUT" })}
                            dataField="optoutemailnotifications"
                        />

                        {this.allowSeeDashboardButtons && (
                            <Column
                                caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.SHOW_ON_DASHBOARD" })}
                                dataField="showondashboard"
                            />
                        )}

                        {this.allowSeeExportAccessButton && (
                            <Column
                                caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.GRANT_EXPORT_ACCESS" })}
                                dataField="exportaccess"
                            />
                        )}

                        {this.allowSeeFinancialFields && (
                            <Column
                                caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.FIELD.FINANCIAL_LIMIT_AMOUNT" })}
                                dataField="userlimit"
                                dataType="currency"
                                format={(num) => Common.FormatCurrencyNum(num, this.props.contract.currency)}
                                allowFiltering={false}
                            />
                        )}

                        {this.allowSeeFinancialFields && (
                            <Column
                                caption={this.props.intl.formatMessage({ id: "GENERAL.FORMS.FIELD.FINANCIAL_LIMIT_CURRENCY" })}
                                dataField="userlimitcurrency"
                            />
                        )}

                        {/* Hidden fields to support the popup */}
                        <Column caption={this.props.intl.formatMessage({ id: "CONTRACT.USERS.FIELD.COMPANY" })} dataField="companyid" setCellValue={this.setCompanyCellValue} visible={false} showInColumnChooser={false} > <Lookup dataSource={this.state.companyOptions} displayExpr="name" valueExpr="companyid" /> </Column> <Column caption={this.props.intl.formatMessage({ id: "CONTRACT.USERS.FIELD.USER" })} dataField="userid" visible={false} showInColumnChooser={false} > <Lookup dataSource={this.getCompanyUserDataSource} displayExpr="display" valueExpr="accountid" /> </Column>

                        {/* ---------------- BUTTON COLUMN ---------------- */}
                        {this.allowEdit && (
                            <Column type="buttons" width={100}>
                                <Button
                                    icon="edit"
                                    hint="Edit"
                                    onClick={(e) => this.gridRef.current.instance().editRow(e.row.rowIndex)}
                                />
                                <Button name="delete" icon="trash" />
                            </Column>
                        )}


                        <Scrolling mode="virtual" showScrollbar={true} useNative={true} />

                        {/* ---------------- TOOLBAR ---------------- */}
                        <Toolbar>
                            <ToolbarItem location="before">
                                <div>
                                    <h3
                                        className="kt-portlet__head-title"
                                        style={{
                                            fontFamily: SystemHelper.getThemeTextFont() ?? "Poppins, Helvetica, sans-serif",
                                            fontSize: "1.2rem",
                                            fontWeight: 500,
                                            color: "#48465b",
                                            padding: 0,
                                            margin: 0,
                                            lineHeight: 1.2
                                        }}
                                    >
                                        <FormattedMessage id="CONTRACT.USERS.TITLE" />
                                    </h3>
                                </div>
                            </ToolbarItem>

                            {this.batchOperationsEnabled && (
                                <ToolbarItem
                                    location="after"
                                    locateInMenu="always"
                                    widget="dxButton"
                                    visible={this.batchOperationsEnabled}
                                    options={{
                                        onInitialized: (e) => {
                                            this.toolbarBatchEditButtonRef = e;
                                        },
                                        icon: this.state.batchEditing ? "close" : "edit",
                                        onClick: () => {
                                            this.gridRef.current.instance().clearSelection();
                                            this.props.closeSnackbar();
                                            if (!this.state.batchEditing && this.batchUnsupportedCustomFieldWarning) {
                                                this.props.enqueueSnackbar(
                                                    this.props.intl.formatMessage({ id: "BATCH_OPS.WARNING.UNSUPPORTED_CF" }),
                                                    { variant: "warning" }
                                                );
                                            }
                                            this.setState({ batchEditing: !this.state.batchEditing });
                                        },
                                        text: this.state.batchEditing
                                            ? this.props.intl.formatMessage({ id: "BATCH_OPS.BUTTON.DISABLE_EDITING" })
                                            : this.props.intl.formatMessage({ id: "BATCH_OPS.BUTTON.EDIT_BATCH" }),
                                        type: this.state.batchEditing ? "default" : "normal",
                                        stylingMode: this.state.batchEditing ? "outlined" : "contained"
                                    }}
                                />
                            )}

                            {this.batchOperationsEnabled && this.state.batchEditing && (
                                <ToolbarItem
                                    location="after"
                                    locateInMenu="auto"
                                    widget="dxButton"
                                    visible={this.batchOperationsEnabled}
                                    options={{
                                        icon: "import",
                                        text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.IMPORT_FROM_EXCEL" }),
                                        onClick: this.importExcelClicked
                                    }}
                                />
                            )}

                            {this.batchOperationsEnabled && this.state.batchEditing && (
                                <ToolbarItem
                                    location="after"
                                    locateInMenu="auto"
                                    widget="dxButton"
                                    visible={this.batchOperationsEnabled}
                                    options={{
                                        onInitialized: (e) => {
                                            this.toolbarBatchButtonRefs.push(e);
                                        },
                                        icon: "download",
                                        onClick: this.downloadImportTemplateClick,
                                        text: "Download Template"
                                    }}
                                />
                            )}

                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                name="addRowButton"
                                showText="always"
                                disabled={this.state.batchEditing}
                                options={{
                                    icon: "plus",
                                    text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.ADD_USER" })
                                }}
                            />

                            {this.allowSeeDashboardButtons && (
                                <ToolbarItem
                                    location="after"
                                    locateInMenu="auto"
                                    widget="dxButton"
                                    disabled={this.state.batchEditing}
                                    options={{
                                        onInitialized: (e) => {
                                            this.btnRemoveFromDashboard = e;
                                        },
                                        icon: "decreaseindent",
                                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.REMOVE_FROM_DASHBOARD" }),
                                        disabled: true,
                                        onClick: this.onbtnRemoveFromDashboardClick,
                                        type: "danger",
                                        stylingMode: "outlined"
                                    }}
                                />
                            )}

                            {this.allowSeeDashboardButtons && (
                                <ToolbarItem
                                    location="after"
                                    locateInMenu="auto"
                                    widget="dxButton"
                                    disabled={this.state.batchEditing}
                                    options={{
                                        onInitialized: (e) => {
                                            this.btnShowOnDashboard = e;
                                        },
                                        icon: "increaseindent",
                                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SHOW_ON_DASHBOARD" }),
                                        disabled: true,
                                        onClick: this.onbtnShowOnDashboardClick,
                                        type: "success",
                                        stylingMode: "outlined"
                                    }}
                                />
                            )}

                            {this.allowSeeExportAccessButton && (
                                <ToolbarItem
                                    location="after"
                                    locateInMenu="auto"
                                    widget="dxButton"
                                    disabled={this.state.batchEditing}
                                    options={{
                                        onInitialized: (e) => {
                                            this.btnRevokeExportAccess = e;
                                        },
                                        icon: "decreaseindent",
                                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.REVOKE_EXPORT_ACCESS" }),
                                        disabled: true,
                                        onClick: this.onbtnRevokeExportAccessClick,
                                        type: "danger",
                                        stylingMode: "outlined"
                                    }}
                                />
                            )}

                            {this.allowSeeExportAccessButton && (
                                <ToolbarItem
                                    location="after"
                                    locateInMenu="auto"
                                    widget="dxButton"
                                    disabled={this.state.batchEditing}
                                    options={{
                                        onInitialized: (e) => {
                                            this.btnGrantExportAccess = e;
                                        },
                                        icon: "increaseindent",
                                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.GRANT_EXPORT_ACCESS" }),
                                        disabled: true,
                                        onClick: this.onbtnGrantExportAccessClick,
                                        type: "success",
                                        stylingMode: "outlined"
                                    }}
                                />
                            )}

                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                name="exportButton"
                                disabled={this.state.batchEditing}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                name="columnChooserButton"
                                disabled={this.state.batchEditing}
                            />
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                name="searchPanel"
                                disabled={this.state.batchEditing}
                            />
                        </Toolbar>

                        {/* ---------------- SUMMARY ---------------- */}
                        <Summary>
                            <TotalItem
                                column="contractuserid"
                                summaryType="count"
                                showInColumn="usercompany"
                            />
                        </Summary>
                    </DataGrid>

                    <input
                        type="file"
                        accept=".xlsx"
                        ref={this.fileImportInputRef}
                        style={{ display: "none" }}
                        onChange={this.importFileSelected}
                    />
                </PortletBody>
            </Portlet>
        );

    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    userProfile: store.auth.userProfile,
    contractTemplate: store.contract.template,
});

const mapDispatchToProps = {
    refreshContractUsers: contractDuck.actions.refreshUsers,
}

export default injectIntl(withSnackbar(connect(mapStateToProps, mapDispatchToProps)(ContractUsers)));
